var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 0.666748C6.64008 0.666748 0.666748 6.64008 0.666748 14.0001C0.666748 21.3601 6.64008 27.3334 14.0001 27.3334C21.3601 27.3334 27.3334 21.3601 27.3334 14.0001C27.3334 6.64008 21.3601 0.666748 14.0001 0.666748ZM14.0001 24.6667C8.12008 24.6667 3.33341 19.8801 3.33341 14.0001C3.33341 8.12008 8.12008 3.33341 14.0001 3.33341C19.8801 3.33341 24.6667 8.12008 24.6667 14.0001C24.6667 19.8801 19.8801 24.6667 14.0001 24.6667ZM19.1734 9.05342L11.3334 16.8934L8.82675 14.3867C8.30675 13.8667 7.46675 13.8667 6.94675 14.3867C6.42675 14.9067 6.42675 15.7467 6.94675 16.2667L10.4001 19.7201C10.9201 20.2401 11.7601 20.2401 12.2801 19.7201L21.0667 10.9334C21.5867 10.4134 21.5867 9.57341 21.0667 9.05342C20.5467 8.53341 19.6934 8.53341 19.1734 9.05342Z",
    fill: "white",
    fillOpacity: 0.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check_circle_outline.40038418e8d2a584e9a208c5d4314537.svg";
export { ForwardRef as ReactComponent };